import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import moment from 'moment';

import useWindowSize from 'app/hooks/useWindowSize';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { ReactComponent as BusinessIcon } from 'app/assets/img/business_icon.svg';
import { formatNumber } from 'utils/helper';
import MonthPickerComponent from 'app/components/MonthPickerComponent';
import { GET_ME } from 'app/pages/App/slice';

interface RevenueProps {}

const Revenue = (props: RevenueProps) => {
  const [monthFilter, setMonthFilter] = useState(moment());
  const translations = useSelector(selectTranslations);
  const infoUser = useSelector(selectInfoUser);
  const { device } = useWindowSize();
  const dispatch = useDispatch();

  useEffect(() => {
    const getMeData = () => {
      dispatch(
        GET_ME({
          month: monthFilter.month() + 1,
          year: monthFilter.format('YYYY'),
        }),
      );
    };
    getMeData();
  }, [dispatch, monthFilter]);

  return (
    <Wrapper style={{ marginBottom: 24 }}>
      <Container device={device} style={{ width: '100%' }}>
        <RevenueContainer>
          <Text style={{ textTransform: 'uppercase' }}>
            {translations?.['b2b.txt.personalRevenue'] ?? ''}
          </Text>
          <MonthPickerContainer>
            <MonthPickerComponent
              valueCalendar={monthFilter}
              onChangeCalendar={value => setMonthFilter(value!)}
            />
          </MonthPickerContainer>
        </RevenueContainer>
        <RevenueNumberContainer style={{ marginTop: 24 }}>
          <Text style={{ fontSize: 14 }}>
            {translations?.['b2b.txt.totalRevenue'] ?? ''}
          </Text>
          <Text style={{ fontSize: 24, color: '#FAB317' }} className="revenue">
            {formatNumber(+(infoUser?.revenue ?? '0')).replaceAll(',', '.')}
            {'đ'}
          </Text>
        </RevenueNumberContainer>
      </Container>
      <Container
        device={device}
        style={{ flexDirection: 'row', alignItems: 'center' }}
        className="agency"
      >
        <div style={{ flexShrink: 0 }}>
          <BusinessIcon />
        </div>
        <div style={{ marginLeft: 16 }}>
          <BusinessTitle>
            {translations?.['b2b.txt.agency'] ?? ''}
          </BusinessTitle>
          <BusinessName>{infoUser?.businessPartner?.name}</BusinessName>
        </div>
      </Container>
    </Wrapper>
  );
};

export default Revenue;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 567px) {
    flex-direction: column;
  }
`;

const Container = styled.div<{ device: string }>`
  border-radius: 20px;
  background: #ffffff;
  padding: ${props => (props.device === 'desktop' ? '40px 32px 32px' : '16px')};
  box-shadow: 0px 20px 20px 0px #0000000d;
  display: flex;
  flex-direction: column;
  &.agency {
    margin-left: 23px;
    @media (max-width: 567px) {
      margin-left: 0;
      margin-top: 24px;
    }
  }
`;

const RevenueContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const MonthPickerContainer = styled.div`
  @media (max-width: 767px) {
    margin-top: 10px;
  }
`;

const RevenueNumberContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Text = styled.p`
  color: #000000;
  font-weight: 600;
  font-size: 20px;
  color: #000000;
  margin: 0;
  &.revenue {
    @media (max-width: 767px) {
      margin-top: 10px;
    }
  }
`;

const BusinessTitle = styled.p`
  color: #000000;
  font-weight: 400;
  font-size: 14px;
  margin: 0;
`;

const BusinessName = styled.p`
  color: #000000;
  font-weight: 500;
  font-size: 16px;
  margin: 0;
  width: max-content;
  max-width: 200px;
  @media (max-width: 567px) {
    max-width: 100%;
    width: auto;
  }
`;
